import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-agent-outreach',
  templateUrl: './agent-outreach.component.html',
  styleUrls: ['./agent-outreach.component.scss']
})
export class AgentOutreachComponent implements OnInit {

  outreachForm = this.fb.group({
    branch: ['']
  });

  outreachData = [];
  branches = [];
  settings: any = {};
  noData = false;
  displayData = false;

  offset = 0;
  limit = 200;
  total = 0;
  hasMore = false;
  loadingMore = false;

  constructor(private sharedService: SharedService, private fb: FormBuilder) {}

  ngOnInit() {
    this.getBranch();
    this.onSubmit();
  }

  getBranch() {
    this.sharedService.getBranch().subscribe(
      data => {
        this.branches = data;
      }
    );
  }

  onSubmit() {
    this.displayData = true;
    this.offset = 0;
    this.outreachData = [];
    this.loadOutreachData();
  }

  loadOutreachData() {
    let payload = {
      ...this.outreachForm.value,
      offset: this.offset,
      limit: this.limit
    };
    this.sharedService.agentOutreachList(payload).subscribe(
      res => {
        if (this.offset === 0) {
          this.outreachData = res.data;
        } else {
          this.outreachData = this.outreachData.concat(res.data);
        }
        this.settings = res.settings;
        this.total = res.total;
        this.hasMore = res.has_more;
        this.noData = this.outreachData.length === 0;
        this.loadingMore = false;
      }
    );
  }

  loadMore() {
    this.loadingMore = true;
    this.offset += this.limit;
    this.loadOutreachData();
  }

  completeAll() {
    const days = prompt('Mark all tasks older than how many days? (based on trigger date)');
    if (days === null) return;
    const daysNum = parseInt(days, 10);
    if (isNaN(daysNum) || daysNum <= 0) {
      alert('Please enter a valid number of days.');
      return;
    }
    if (!confirm('Mark all outreach tasks older than ' + daysNum + ' days as complete? This cannot be undone.')) return;
    this.sharedService.agentOutreachCompleteAll({
      ...this.outreachForm.value,
      days: daysNum
    }).subscribe(
      data => {
        if (data.success) {
          this.onSubmit();
        }
      }
    );
  }

  completeTask(item) {
    this.sharedService.agentOutreachComplete({
      client_id: item.client_id
    }).subscribe(
      data => {
        if (data.success) {
          this.outreachData = this.outreachData.filter(
            row => row.client_id !== item.client_id
          );
          this.total--;
          this.noData = this.outreachData.length === 0;
        }
      }
    );
  }

  saveNote(item) {
    this.sharedService.agentOutreachSaveNote({
      client_id: item.client_id,
      notes: item.notes
    }).subscribe(
      data => {
        item._saved = true;
        setTimeout(() => { item._saved = false; }, 2000);
      }
    );
  }

  reset() {
    this.outreachForm.patchValue({
      branch: ''
    });
  }
}
